import React,{Component} from "react";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class AppNotice extends Component{

    componentDidMount() {
        toast.configure();
    }

    render(){
        return <>

        </>
    }
}
